import { render, staticRenderFns } from "./DoneHomework.vue?vue&type=template&id=11ccf7f7&scoped=true&"
import script from "./DoneHomework.vue?vue&type=script&lang=js&"
export * from "./DoneHomework.vue?vue&type=script&lang=js&"
import style0 from "./DoneHomework.vue?vue&type=style&index=0&id=11ccf7f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ccf7f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
